import {combineReducers} from 'redux'

import auth from './auth'
import cart from './cart'
import category from './category'
import image from './image'
import loyalty from './loyalty'
import menu from './menu'
import order from './order'
import report from './report'
import payment from './payment'
import searchresults from './searchresults'
import settings from './settings'
import superuser from './superuser'
import superusers from './superusers'
import table from './table'
import user from './user'
import users from './users'
import venue from './venue'
import venues from './venues'



const createReducer=(asyncReducers) =>
    combineReducers({
        auth,
        cart,
        category,
        image,
        loyalty,
        menu,
        order,
        report,
        payment,
        searchresults,
        settings,
        superuser,
        superusers,
        table,
        user,
        users,
        venue,
        venues,
        ...asyncReducers
    })

export default createReducer
